import { render } from "./EventSettings.vue?vue&type=template&id=27e59ca5&scoped=true"
import script from "./EventSettings.vue?vue&type=script&lang=js"
export * from "./EventSettings.vue?vue&type=script&lang=js"

import "./EventSettings.vue?vue&type=style&index=0&id=27e59ca5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\bfern\\Documents\\la-vuelta-trama\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e59ca5"]])

export default __exports__